class IADropdownFaq {

    /**
     * Creates an instance of IADropdownFaq.
     * @param {NodeList} allFaqs
     * @memberof IADropdownFaq
     */
    constructor(allFaqs) {
        this.allFaqs = allFaqs
        this.allFaqs.forEach(faq => faq.style.height = faq.children[0].clientHeight+'px')
    }

    openCloseFaq(actualQuestion) {
        
        if (actualQuestion.classList.contains('active')) {
            actualQuestion.classList.remove('active')
            actualQuestion.style.height = actualQuestion.children[0].clientHeight+'px'
        } else {
            if (window.innerWidth > 1024) {
                const openedFaq = Array.from(this.allFaqs).filter(faq => faq.classList.contains('active'))
                if (openedFaq.length > 0) {
                    openedFaq.forEach(faq => {
                        faq.classList.remove('active')
                        faq.style.height = faq.children[0].clientHeight+'px'
                    });
                }
            }

            actualQuestion.classList.add('active')
            actualQuestion.style.height = (actualQuestion.children[0].clientHeight + actualQuestion.children[1].clientHeight)+'px'
        }
    }

    resize() {
        this.allFaqs.forEach(faq => {
            if(!faq.classList.contains('active')){
                faq.style.height = faq.children[0].clientHeight+'px'
            } else {
                faq.style.height = (faq.children[0].clientHeight + faq.children[1].clientHeight)+'px'
            }
        })
    }
}

function filterFaqs(buttonClicked, allFaqs){
    const filterID = buttonClicked.hash.replace('#','')
    if(filterID === 'all') {
        allFaqs.forEach(faq => faq.classList.remove('hide'))
        return
    }

    const faqsToHide = Array.from(allFaqs).filter(faq => {
        const categoriesFaq = faq.dataset.filter.split(',')
        if (!categoriesFaq.includes(filterID)) {
            return faq
        }
    })
    allFaqs.forEach(faq => faq.classList.remove('hide'))
    faqsToHide.forEach(faq => faq.classList.add('hide'))
}

export {IADropdownFaq, filterFaqs}